const CHART_ACTIVE_CLASS = "active"

const getIsElementFromAbove = (element) => {
  const rect = element.getBoundingClientRect();

  return rect.top < 0;
}

const getElementAligment = (element) => {
  const rect = element.getBoundingClientRect();

  return rect.bottom < 0 ? 'start' : 'end';
}

export default () => ({
  chartItems: undefined,
  timelineItems: undefined,

  observeTimelineItems(callback, options = {}) {
    const _this = this
    let observerOptions = {
      rootMargin: '0px',
      threshold: 0.7,
      ...options
    }

    var observer = new IntersectionObserver(observerCallback, observerOptions);

    function observerCallback(entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          callback(entry.target)
        }
      });
    };

    this.timelineItems?.forEach(function(element) {
      if (element) {
        observer.observe(element);
      }
    });
  },

  handleAnimateItem(element) {
    const isFromAbove = getIsElementFromAbove(element)

    if (isFromAbove) {
      element.classList.add("shown-without-transition")
    }

    element.classList.add("shown")
  },

  handleChartActiveItem(target) {
    const id = target.getAttribute('id')

    this.chartItems?.forEach(element => element.classList.remove(CHART_ACTIVE_CLASS))
    const targetElement = this.$refs.chart.querySelector(`[href='#${id}']`)
    if (targetElement) {
      targetElement.classList.add(CHART_ACTIVE_CLASS)
    }
  },

  bindScrollToYear() {
    const handleClick = (event) => {
      event.preventDefault()
      console.log('event.target: ', event.target)
      const id = event.target.closest('a').getAttribute('href')
      const element = this.$refs.timeline.querySelector(id)

      if (!element) {
        return
      }

      const aligment = getElementAligment(element)

      element.scrollIntoView({
        behavior: 'smooth',
        block: aligment,
      });
    }

    this.chartItems.forEach(element => {
      element.addEventListener('click', handleClick);
    });
  },

  handleChartEntryAnimation() {
    let observerOptions = {
      rootMargin: '0px',
      threshold: 1,
    }

    var observerShow = new IntersectionObserver(showChart, observerOptions);
    var observerHide = new IntersectionObserver(hideChart, {...observerOptions, threshold: 0});

    function showChart(entries, observerShow) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("shown")
        }
      });
    };

    function hideChart(entries, observerHide) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          entry.target.classList.remove("shown")
        }
      });
    };

    if (this.$refs.chart) {
      observerShow.observe(this.$refs.chart);
      observerHide.observe(this.$refs.chart);
    }
  },

  init() {
    this.timelineItems = this.$refs.timeline.querySelectorAll('.timeline-item')
    this.chartItems = this.$refs.chart.querySelectorAll('.chart__item')

    this.observeTimelineItems((params) => this.handleAnimateItem(params), { threshold: 0.3 })
    this.observeTimelineItems((params) => this.handleChartActiveItem(params))
    this.handleChartEntryAnimation()
    this.bindScrollToYear()
  },
});
